import {createRoot} from "react-dom/client";
import {ReactNode} from "react";

export const renderReactNode = (node: ReactNode) => {
  const container = document.createElement('div');
  const root = createRoot(container!);
  root.render(node);
  return container;
}